const processHelpData = (helpArticles) => {

  let categories = helpArticles.data;

  const getCategoryByID = (id) => {
    for (let i = 0; i < categories.length; i++) {
      if (Number.parseInt(categories[i].id) === Number.parseInt(id))
        return categories[i];
    }
  };

  return {
    categories: categories,
    getCategoryByID: getCategoryByID
  };
};

export default processHelpData;
